import axios from 'axios';
import './latestVersionAlert.css';
import Swal from "sweetalert2";
import moment from 'moment';

export default function useLatestVersionAlert(params: any = {}) {
  // params for configurable future use.
  // this hook will be triggered when you call check version Update, and will show the popup let user to refresh.
  // future possible customize point: target url, ajax call maker, or useContext to passing the trigger method.
  const localStorageKey = 'LAST_MODIFIED';
  const defaultBaseURL = window.location.protocol + '//' + window.location.host;
  const localBaseURL = params.baseURL || defaultBaseURL;
  const url = `/manifest.json`;

  // Public Methods    
  function checkVersionUpdate() {
    makeCheckingUpdateCall();
  }

  // private methods
  function makeCheckingUpdateCall(baseURL = localBaseURL) {
    let newInstance = axios.create({
      baseURL: baseURL,
      timeout: 1000,
      headers: {
        'Accept': '*/*',
        'Cache-Control': 'no-cache',
      }
    });
    newInstance
      .get(url)
      .then(response => {
        let { headers } = response || {};
        let newLastModifiedTime = headers['last-modified'] || '';
        if (newLastModifiedTime) {
          const storedLastModified = localStorage.getItem(localStorageKey);
          if (storedLastModified === null || storedLastModified === '') {
            localStorage.setItem(localStorageKey, newLastModifiedTime)
          } else if (moment(newLastModifiedTime).isAfter(storedLastModified)) {
            let timerInterval: any = null;
            Swal.fire({
              title: 'Latest version available!',
              iconHtml: '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAViSURBVHhe7ZrLbxtVFIedFkopjwLi0bKIShcQIRRqYc/DiR8htefOjEMT4oYNTYEdSCBVlUBCFqz4A9h1gRRhdzweP5OS0IDoI3GChLrpBhBBiB1SIUkfSaERiYZz7BsgNJVnJmknI+4nXSU+9syc85t7z7l35voYDAaDwWAwGE2IfxHf1TGqPtShbfEGPqKv1O2NI2hSt1hJjgpF5RKflxe80MDXX8WqOsZlSZyG4YxgVjrWebrXjJ7rN/k8WeZ1suiFxulkOQI+d473moFM4jgNxx68LkUxeLj7qOprgqE8yRuJh73QQrmDe3ldOSpW1AUUgcvJXTQs63C6/GX0fL8ZzJFBavIcnJY4Uu+9OjlDTdZ4LhPfBQfN84a8FKh0P0LNnqPeI/LyErQr0ULqPmpuDh4I4+g6r8sLkeqh3dTsOboLqQchhmsQy++2biSWk3pGhYQSLUStK7fFiGNPpnHgTaXm5qwKgL2AM+L71tRZDzUuE98H1atRHewKAElwViipUP7W1livNYyBy5M5xwI0csE/NdZLDX13LACqhycI6WQ/HuzF1qmpTzkeAvUuBAf+r5Og7QO3GI7jYAIwAZgATAAmABOACeB5AdB3iGMFmul4OexlAdoKqbthOl+DtcAU/k/NzfGKAOGz4e1cXj4hjvSMiWX5LT734uP0q79Jp9MtaTPdQj9aw20B1rx/gP+p+SZ4g98JPv7S9fWAGZtMmUJJmecN5X1fn28b/Ykz3BKg0WXlSbGahGvLl3FJHqomZ8GX8Vt14QO5g3vFUvJVwZCHQyM9Zqx2GIWY8GelPfQn9nFXAFKDoK9A8H+IlaQpDvfgM4kbVpJY0JAEoah8E5sCEYrK9+sNCUu4PQTCp/v2QOL6tmP0JXwvYeuBRuvH0g7ekMtd04fxZc4E5gD6lXXcFiCokfciZ17GOz8DwczD36t2/Ah/GN7OF+QLOByCmnSMmq3jpgB4PQj6qlhVbwgaiYAPl8EXe3Uc4PKJ9tCpnhU411z7UMTeo303BYC7/QbeOU6TMvSz/TpO4TQyHJuEc+XI69RkDZcFKEbO4ussmeBnrOG26zgFcsAr0YkUvhqrUJM1XBPAxK5LfoAMvuwvb6CMUUQt8UxoOImP9n+EGZF1Ed0SoPFOEus/meWN/p3U7JgOQ3oUzrWE5wxmyQPU3By3BMAXmOAszAHIvH8keS81OwYFgBjqAsB84n5qbo57QyDdAs7+BDO5FeGk0kqtjnnBkJ4WYQjApGrGE0MAAWdH8Z0+ZO5+anIMlMABTIKQV0rUZA03BYDFzNuNMkhOUZNjYEIFZRCrgHSUmqzhpgCBgvwEX1SuwyTGDGRJgJptEzgZfx4nQrBcnrWVABEMGhKRaxskQPiP6r3AUC46mQD5T/jvEuhUGGJ4h5qts1qOYAwtBT6981tkcJ0Pd+5iPYCCXG37oM2yCOGh8D3gdzU2PYBrifO+tM/RJMoX1MlX9WSkyUeo6Y6CmxuEsvozigBVYVrIS3761S0RSnJIKKkXVpfD7Zn4Y/Qr++DWMtxiJlaT1wSDDOLMDHPDbWvrPPk58ElXK19Sp1AE8ANndJpgqL1+nexvHzq0G3tnsCg9i/7BXf8M80asVn8ytLEHIqtwmcRxFCGCPUEnf0KJWncXxmY03I8I16i1jkk76OUb9Pm2QVJ8F3rDJczo2CvFcmPnCuYprPO4nW9TH4n9G7hIHJz7HLrUb3DRm3ZhbErLk0Wxoi7iqk/6rwAU7CVCUR2EIHNwt7/jDTIH/mDAM9Dtq3xZedPxEyArRM/BNBWqw21r4ylb5RanzfXyZsIKisFgMBgMBoNhF5/vLw+rLSs2/JJYAAAAAElFTkSuQmCC" alt="Refresh" width="64px" />',
              html:
                '<p>A latest version of this application is now available. Please click on the button below to download the latest code. <br/><br/></p>' +
                '<button id="refresh" class="ui button primary" style="font-size:1.8rem;">' +
                'Refresh' +
                '</button><br/><br/>' +
                'This page will refresh automatically in <strong></strong> seconds <br/><br/>',
              timer: 30000,
              customClass: {
                container: 'swal2-refresh-alert'
              },
              didOpen: () => {
                const content: any = Swal.getHtmlContainer();
                const $ = content.querySelector.bind(content);
                const refresh = $('#refresh');
                Swal.showLoading();

                refresh.addEventListener('click', () => {
                  localStorage.setItem(localStorageKey, newLastModifiedTime);
                  window.location.reload();
                })

                timerInterval = setInterval(() => {
                  if (Swal) {
                    let timeLeft: number = Swal?.getTimerLeft() || 0;
                    let time = (timeLeft / 1000).toFixed(0);
                    let container: any = Swal?.getHtmlContainer() || null;
                    let selector: any = container ? container?.querySelector('strong') : null;
                    if (selector) {
                      selector.textContent = time;
                    }
                  }
                }, 100)
              },
              willClose: () => {
                localStorage.setItem(localStorageKey, newLastModifiedTime);
                clearInterval(timerInterval);
                window.location.reload();
              }
            });
          }
        }
      })
      .catch(async (error) => {
        // handle fail
        console.log(JSON.stringify(error));
      });
  }

  return {
    checkVersionUpdate
  };
}